var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6667C10.9205 11.6667 11.6667 10.9205 11.6667 10C11.6667 9.07952 10.9205 8.33333 10 8.33333C9.07956 8.33333 8.33337 9.07952 8.33337 10C8.33337 10.9205 9.07956 11.6667 10 11.6667Z",
    fill: "#808191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2834 9.7083C16.9407 6.32039 13.6439 4.11484 10 4.16667C6.35613 4.11484 3.05937 6.32039 1.7167 9.7083C1.65002 9.89705 1.65002 10.1029 1.7167 10.2916C3.05937 13.6796 6.35613 15.8851 10 15.8333C13.6439 15.8851 16.9407 13.6796 18.2834 10.2916C18.35 10.1029 18.3502 9.89705 18.2834 9.7083ZM10.0019 13.3333H10C8.15906 13.3333 6.6667 11.8409 6.6667 10C6.6667 8.15903 8.15906 6.66667 10 6.66667C11.841 6.66667 13.3334 8.15903 13.3334 10C13.3339 11.8404 11.8423 13.3328 10.0019 13.3333Z",
    fill: "#808191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.1cf1a5a7fa9f69613195a0feca7f7401.svg";
export { ForwardRef as ReactComponent };